import React from 'react'
import AiHero from '../../Components/Automation/AiHero'
import WhyAIAutomation from '../../Components/Automation/WhyAIAutomation'
// import IndustriesWeServe from '../../Components/Automation/IndustriesWeServe'
import { ArrowRight } from 'lucide-react'
import Banner from '../../Components/Banner';
import { Helmet } from 'react-helmet-async';

const featuresData = [
    {
        id: 1,
        title: "AI-Powered Enterprise Automation",
        description: "Make your workflows smoother with AI agents that handle approvals, reporting, vendor tasks, and employee queries quickly, accurately, and effortlessly.",
        image: "/assets/product/agentic1.png",
    },
    {
        id: 2,
        title: "Customer Experience Agents",
        description: "Deploy AI-powered virtual agents that naturally engage with customers, understand their needs, and resolve issues early creating smoother, faster, and more helpful experiences.",
        image: "/assets/product/agentic2.png",
    },
    {
        id: 3,
        title: "AI Agents for IT & Operations",
        description: "Stay ahead with AI that helps you monitor systems, fix issues early, and prevent downtime.",
        image: "/assets/product/agentic3.png",
    },
    {
        id: 4,
        title: "Knowledge & Decision Agents",
        description: "Help your teams and leaders make faster, confident decisions with AI that turns complex data into simple, clear insights in minutes.",
        image: "/assets/product/agentic4.png",
    },
    {
        id: 5,
        title: "Custom Enterprise AI Agents",
        description: "Create custom AI agents designed around your business from finance tasks to supply chains built to simplify work and deliver real results.",
        image: "/assets/product/agentic5.png",
    },
];

// --- DATA ---
const services = [
    {
        id: 1,
        title: "Cloud Services",
        category: "service",
        desc: "Elevate your applications with Mobikode’s cloud services designed for performance optimization, data protection and simplicity in migrations. We also cut costs so you can do more of what really matters!",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]", // Deep Blue Gradient
    },
    {
        id: 2,
        title: "Cloud Migration",
        category: "service",
        desc: "The future is now. Cloud is essential for organizations today to be more efficient and profitable. Mobikode can help you migrate your data into this new way of thinking by strengthening the core operations strategy and build a future-ready organization.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]", // Blue to Royal Blue (Replaced Orange)
    },
    {
        id: 3,
        title: "DevOps Services",
        category: "service",
        desc: "We implement a continuous and data-driven approach to help you realize better outcomes with your infrastructure through the latest tech trends, tools, techniques – and even old-fashioned hard work!",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]", // Blue to Grayish Blue
    },
    {
        id: 4,
        title: "Cloud Services",
        category: "service",
        desc: "Elevate your applications with Mobikode’s cloud services designed for performance optimization, data protection and simplicity in migrations. We also cut costs so you can do more of what really matters!",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]", // Deep Blue Gradient
    },
    {
        id: 5,
        title: "Cloud Migration",
        category: "service",
        desc: "The future is now. Cloud is essential for organizations today to be more efficient and profitable. Mobikode can help you migrate your data into this new way of thinking by strengthening the core operations strategy and build a future-ready organization.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]", // Blue to Royal Blue (Replaced Orange)
    },
    {
        id: 6,
        title: "DevOps Services",
        category: "service",
        desc: "We implement a continuous and data-driven approach to help you realize better outcomes with your infrastructure through the latest tech trends, tools, techniques – and even old-fashioned hard work!",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]", // Blue to Grayish Blue
    },
];

const toolsData = [
    {
        id: 1,
        title: "Autonomous Efficiency",
        desc: "AI agents that handle routine tasks, saving time and effort.",
    },
    {
        id: 2,
        title: "Proactive Intelligence",
        desc: "Stay ahead by spotting issues early, acting quickly, and making smarter, data-driven decisions.",
    },
    {
        id: 3,
        title: "Enterprise-Grade Security",
        desc: "Built to grow with you, stay compliant, and support global ambitions.",
    },
    {
        id: 4,
        title: "Custom AI Agents",
        desc: "Solutions thoughtfully built for HR, finance, IT, operations, and beyond.",
    },
];

const outcomesData = [
    {
        id: 1,
        text: "Faster, data-driven decision-making",
    },
    {
        id: 2,
        text: "Single source of truth across the enterprise",
    },
    {
        id: 3,
        text: "Predictive insights & automation",
    },
    {
        id: 4,
        text: "Improved efficiency, cost control & revenue growth",
    },
];

const whyMobikodePoints = [
    "Business-first analytics (not tool-first)",
    "Strong cloud & enterprise data expertise",
    "AI-powered, future-ready solutions",
    "Scalable delivery models (project or managed)",
    "Proven experience across industries",
];

const approachData = [
    {
        id: 1,
        step: "01",
        title: "Enterprise-Grade Expertise",
        desc: "We have hands-on experience delivering AI solutions that truly scale.",
    },
    {
        id: 2,
        step: "02",
        title: "Security & Compliance First",
        desc: "We keep your data safe and aligned with global standards.",
    },
    {
        id: 3,
        step: "03",
        title: "Customizable & Scalable",
        desc: "AI agents that grow with your business, every step forward.",
    },
    {
        id: 4,
        step: "04",
        title: "End-to-End Partnership",
        desc: "We help you adopt AI smoothly, from planning to execution.",
    },
];

function AgenticAI() {
    return (
        <div>
            <Helmet>
                <title>
                    Agentic AI Services for Enterprises | AI Agents & Automation | Mobikode
                </title>

                <meta
                    name="description"
                    content="Mobikode delivers Agentic AI services for enterprises, building autonomous AI agents that automate complex workflows, improve decision-making, enhance customer experiences, and drive operational efficiency."
                />

                <meta
                    name="keywords"
                    content="Agentic AI Services, Agentic AI Solutions, Enterprise AI Agents, AI Agent Development, AI Automation Services, Autonomous AI Agents, Custom AI Agents, Enterprise AI Automation, AI Workflow Automation, AI Customer Experience Agents, AI Agents for IT Operations, Knowledge AI Agents, Decision Intelligence AI, Custom Enterprise AI Solutions"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/agentic-ai-services"
                />

                <meta
                    property="og:title"
                    content="Agentic AI Services for Enterprises | AI Agents & Automation | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Build smarter and more autonomous business operations with Mobikode's Agentic AI solutions. Deploy intelligent AI agents for enterprise automation, customer experience, IT operations, decision support, and custom business workflows."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/agentic-ai-services"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/product/bg3.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Agentic AI Services for Enterprises | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Explore Mobikode's Agentic AI services for enterprise automation, customer experience, IT operations, knowledge management, decision support, and custom AI agent development."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/product/bg3.png"
                />
            </Helmet>
            <AiHero
                title="Agentic AI Services for Enterprises"
                text="At Mobikode, we build autonomous AI agents that take care of complex work behind the scenes. They help simplify everyday workflows, support better decision-making, and improve overall efficiency as your business grows."
                imgData="/assets/product/bg3.png"
            />
            <section className="w-full pt-16 lg:pt-[100px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[15px] lg:px-[80px]">
                    {/* Mobile me flex-col (stacked) aur desktop me flex-row (side-by-side) rakha gaya hai. Fixed height sirf lg screens ke liye. */}
                    <div className="relative w-full flex flex-col lg:flex-row lg:items-center group lg:h-[507px]">

                        {/* Image Box: Mobile pe relative aur fix height (250px), Desktop pe absolute right */}
                        <div className="relative lg:absolute top-0 right-0 w-full lg:max-w-[656px] h-[250px] md:h-[350px] lg:h-full bg-gray-100 overflow-hidden">
                            <img
                                src="/assets/product/img3.png"
                                alt="ai automation"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>

                        {/* Text Box: Mobile pe -mt-[40px] dekar image ke upar thoda overlap kiya hai. Desktop pe margin zero (lg:mt-0). */}
                        <div className="relative z-20 w-[92%] sm:w-[85%] lg:w-full max-w-[750px] mx-auto lg:mx-0 bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] px-[20px] py-[30px] lg:px-[60px] lg:py-[80px] -mt-[40px] lg:mt-0">

                            <h3 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] font-sora mb-[15px] lg:mb-[35px] leading-[1.3]">
                                Unlock Enterprise-Scale Efficiency, Innovation, and Growth with Agentic AI
                            </h3>
                            <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-[500] font-graphik text-justify">
                                At Mobikode, we help businesses use Agentic AI to work smarter and grow faster. These intelligent systems don’t just follow instructions they understand, decide, and take action. We focus on building practical solutions that improve efficiency, spark innovation, and support real business outcomes.
                            </p>

                            {/* Bottom Borders */}
                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>

                        </div>

                    </div>
                </div>
            </section>
            <WhyAIAutomation title="Our Agentic AI Service Offerings" fData={featuresData} />
            <section className="w-full bg-[#FDFDFD] pb-16 lg:pb-24 relative overflow-hidden">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] relative z-10">
                    <div className="mb-[30px] lg:mb-[60px]">
                        <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] text-left">
                            Why Choose Us?
                        </h2>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
                        {approachData.map((item) => (
                            <div
                                key={item.id}
                                className="relative bg-[#F0F0F0] p-8 min-h-[180px] flex flex-col justify-center overflow-hidden group transition-all duration-300 hover:shadow-lg hover:-translate-y-1 rounded-sm"
                            >
                                <div className="relative z-10">
                                    <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora mb-2 leading-tight">
                                        {item.title}
                                    </h3>
                                    <p className="text-[#49577A] text-[14px] lg:text-[16px] font-[500] font-graphik leading-snug">
                                        {item.desc}
                                    </p>
                                </div>
                                <div
                                    className="absolute bottom-0 right-0 w-[180px] h-[140px] pointer-events-none transition-transform duration-500 group-hover:scale-110 opacity-50 lg:opacity-100"
                                >
                                    <img src="/assets/career/wrap1.svg" alt="" className="w-full h-full object-contain object-bottom-right" />
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </section>
            <section className="w-full bg-[#FDFDFD] pb-10 lg:pb-16 relative">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] relative z-10">
                    <div className="flex flex-col lg:flex-row gap-10 lg:gap-20 items-start">
                        <div className="w-full lg:w-[40%] lg:sticky lg:top-24">
                            <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] text-left">
                                Value Proposition
                            </h2>
                        </div>
                        <div className="w-full lg:w-[60%] flex flex-col gap-6">
                            {toolsData.map((item) => (
                                <div
                                    key={item.id}
                                    className="bg-white border border-[#E2E8F0] border-b-[4px] border-b-[#01386A] hover:border-b-[#e86c15] transition-colors duration-300 p-8 lg:px-10 lg:py-10 flex flex-col justify-center cursor-pointer group"
                                >
                                    <h3 className="text-[#01386A] text-[18px] lg:text-[20px] font-[600] font-sora mb-2">
                                        {item.title}
                                    </h3>
                                    <p className="text-[#49577A] text-[14px] lg:text-[16px] font-[500] font-graphik">
                                        {item.desc}
                                    </p>
                                </div>
                            ))}
                        </div>

                    </div>

                </div>
            </section>
            <Banner title="Agentic AI Services for Enterprises" text=" Empowering businesses with intelligent, autonomous AI solutions that drive efficiency and innovation." />
        </div>
    )
}

export default AgenticAI
